import React from 'react';
import PropTypes from 'prop-types';
import styles from './CustomNewButton.module.css';

const CustomNewButton = ({
  children,
  label, // TODO - use children instead of label on all pages using CustomNewButton and remove this property
  tooltip,
  variant,
  onClick,
  disabled,
  style,
  customStyle,
  icon,
}) => {
  return (
    <div className={styles.tooltip} style={style}>
      <button
        className={`${styles.btn} ${
          variant === 'primary'
            ? styles.btnPrimary
            : variant === 'secondary'
              ? styles.btnSecondary
              : variant === 'success'
                ? styles.btnSuccess
                : variant === 'primary2'
                  ? styles.btnPrimary2
                  : variant === 'outline'
                    ? styles.btnOutline
                    : variant === 'gradient'
                      ? styles.btnGradient
                      : variant === 'orange'
                        ? styles.btnOrange
                        : variant === 'info'
                          ? styles.btnInfo
                          : styles.btnDanger
        }`}
        style={customStyle}
        onClick={onClick}
        disabled={disabled}
      >
        {icon && <span className={styles.btnIcon}>{icon}</span>}
        {label ? label : children}
      </button>
      {tooltip && (
        <span className={styles.tooltiptext} id="addSeasonTooltip">
          {tooltip}
        </span>
      )}
    </div>
  );
};

CustomNewButton.propTypes = {
  children: PropTypes.node,
  label: PropTypes.string,
  tooltip: PropTypes.string,
  variant: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  style: PropTypes.object,
  customStyle: PropTypes.object,
  icon: PropTypes.node,
};

export default CustomNewButton;
